import SettingStore from "stores/settings";
import { useDisplayLearningActivityCardImage } from "lib/hocs/useLearningActivityCardState";
import {
  MODE_FULL,
  PROGRESS_ALL,
  SORT_CREATED_DATE,
  NOOFCOURSES,
  STORAGE_KEY_LEARNING_VIEW,
  STORAGE_KEY_FILTER_STATUS,
  STORAGE_KEY_SORT_ORDER,
  FILTER_INITIAL_TAGS,
} from "../constants";

const getViewState = () => {
  const displayImageSetting = useDisplayLearningActivityCardImage();
  const storedLearningView =
    localStorage.getItem(STORAGE_KEY_LEARNING_VIEW) === "true";
  const displayListView =
    storedLearningView !== null && storedLearningView !== undefined
      ? storedLearningView
      : !displayImageSetting;

  return displayListView;
};

export const FILTER_INITIAL_STATE = {
  searchText: "",
  selectedTags: FILTER_INITIAL_TAGS,
  categoryId: 0,
  sortBy: localStorage.getItem(STORAGE_KEY_SORT_ORDER) || SORT_CREATED_DATE,
  mode: MODE_FULL,
  status: localStorage.getItem(STORAGE_KEY_FILTER_STATUS) || PROGRESS_ALL,
  displayAdminCourses: false,
};

// initial state
export const initialState = {
  isAdmin: false,
  isBt: SettingStore.isBt(),
  viewLimit: false,
  viewLimitNr: 3,
  listView: getViewState(),
  displayViewToggle: true,
  searching: false,
  personalId: null,
  categories: {},
  categoryHierarchy: {},
  trainingCategories: [],
  courses: [],
  programs: [],
  filteredCourses: {},
  filteredPrograms: {},
  tags: [],
  filter: FILTER_INITIAL_STATE,
  noOfCourses: NOOFCOURSES,
  totalPercentCompleted: 0,
};
